export default "__VITE_ASSET__DhthdBfD__"